import type { Settings } from "./settings-manager.js";

export const DEFAULT_SETTINGS = {
	transport: "auto",
	steeringMode: "one-at-a-time",
	followUpMode: "one-at-a-time",
	compaction: {
		enabled: true,
		reserveTokens: 16384,
		keepRecentTokens: 20000,
		maxContextRatio: 0.75,
	},
	toolOutput: {
		maxBytes: 32 * 1024,
		maxLines: 800,
	},
	contextGc: {
		enabled: true,
	},
	voice: {
		silenceMs: 800,
	},
	webtools: {
		timeoutSecs: 15,
	},
	disabledTools: [],
	toolOutputView: "peek",
	branchSummary: {
		reserveTokens: 16384,
		skipPrompt: false,
	},
	retry: {
		enabled: true,
		maxRetries: 3,
		baseDelayMs: 2000,
		provider: {
			maxRetryDelayMs: 60000,
		},
	},
	hideThinkingBlock: false,
	quietStartup: false,
	collapseChangelog: false,
	enableInstallTelemetry: true,
	enableSkillCommands: true,
	enableSubagent: true,
	warmSubagents: false,
	maxSubagentDepth: 2,
	nestedSubagentConcurrency: 2,
	enableTodoWrite: true,
	enablePluginTools: false,
	pluginInstallScope: "user",
	deferMcpSchemas: true,
	enableWebTools: false,
	enableSemanticIndex: true,
	embsearchThresholdBytes: 0,
	learnMaxSessions: 20,
	learnMaxAgeDays: 30,
	learnMinRepeats: 2,
	learnMinRequestRepeats: 3,
	learnMaxProposals: 8,
	light: false,
	terminal: {
		showImages: true,
		imageWidthCells: 60,
		clearOnShrink: false,
		showTerminalProgress: false,
		chimeOnTurnComplete: false,
	},
	images: {
		autoResize: true,
		blockImages: false,
	},
	tips: {
		enabled: true,
		seen: [],
		starNudges: 0,
	},
	doubleEscapeAction: "tree",
	treeFilterMode: "default",
	editorBorder: "box",
	editorPaddingX: 1,
	autocompleteMaxVisible: 5,
	markdown: {
		codeBlockIndent: "  ",
	},
	warnings: {
		anthropicExtraUsage: true,
		websearchApiKey: true,
	},
	packages: [],
	extensions: [],
	skills: [],
	prompts: [],
	slashCommands: [],
	themes: [],
} satisfies Settings;
